import React, { useCallback } from "react";
import "./index.css";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx-js-style";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { renameJSONKeys } from "../utlis";
import { formatForExcel } from "./service";
import { formatForExcel1 } from "./service1";
import { formatForExcel2 } from "./service2";

function ExportButtons({ data = [], fileName = "export", columns = [] }) {
  console.log('data: ', fileName, data);

  const getData = useCallback(() => renameJSONKeys(data, columns), [data, columns]);

  // Helper: Convert data to worksheet and download as Excel

  const exportExcel1 = () => {
    const aoa = formatForExcel(data);
    const ws = XLSX.utils.aoa_to_sheet(aoa);

    const invoiceHeader = ["Invoice Date", "Invoice Amount", "Invoice Number", "PO Number"];
    const fullPaymentHeader = ["Payment Mode", "Pay Amount", "Accounting Date", "Payment Date", "Payment Number"];
    const singlePaymentHeader = ["Payment Mode"];

    aoa.forEach((row, rowIndex) => {
      const trimmedRow = row.map(cell => (cell || "").toString().trim());
      const meaningful = trimmedRow.filter(cell => cell !== "");

      const isInvoiceHeader = JSON.stringify(meaningful) === JSON.stringify(invoiceHeader);
      const isFullPaymentHeader = JSON.stringify(meaningful) === JSON.stringify(fullPaymentHeader);
      const isSinglePaymentHeader = JSON.stringify(meaningful) === JSON.stringify(singlePaymentHeader);

      if (isInvoiceHeader || isFullPaymentHeader || isSinglePaymentHeader) {
        row.forEach((cellValue, colIndex) => {
          if (cellValue && cellValue.toString().trim() !== "") {
            const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
            const cell = ws[cellRef];
            if (cell) {
              cell.s = {
                fill: { fgColor: { rgb: "A03D57" } }, // Brown background
                font: { bold: true, color: { rgb: "FFFFFF" } }, // White bold text
              };
            }
          }
        });
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${fileName}.xlsx`);
  };

  const exportExcel2 = () => {
    const aoa = formatForExcel1(data);
    const ws = XLSX.utils.aoa_to_sheet(aoa);

    const invoiceHeader = ["Individual Invoice Amount", "Invoice Date", "Invoice Number", "PO Number", "Vendor Name"];
    const fullPaymentHeader = ["Payment Mode", "Pay Amount", "Accounting Date", "Payment Date", "Payment Number"];
    const singlePaymentHeader = ["Payment Mode"];

    aoa.forEach((row, rowIndex) => {
      const trimmedRow = row.map(cell => (cell || "").toString().trim());
      const meaningful = trimmedRow.filter(cell => cell !== "");

      const isInvoiceHeader = JSON.stringify(meaningful) === JSON.stringify(invoiceHeader);
      const isFullPaymentHeader = JSON.stringify(meaningful) === JSON.stringify(fullPaymentHeader);
      const isSinglePaymentHeader = JSON.stringify(meaningful) === JSON.stringify(singlePaymentHeader);

      if (isInvoiceHeader || isFullPaymentHeader || isSinglePaymentHeader) {
        row.forEach((cellValue, colIndex) => {
          if (cellValue && cellValue.toString().trim() !== "") {
            const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
            const cell = ws[cellRef];
            if (cell) {
              cell.s = {
                fill: { fgColor: { rgb: "A03D57" } }, // Brown background
                font: { bold: true, color: { rgb: "FFFFFF" } }, // White bold text
              };
            }
          }
        });
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${fileName}.xlsx`);
  };

  const exportExcel3 = () => {
    const aoa = formatForExcel2(data);
    const ws = XLSX.utils.aoa_to_sheet(aoa);

    const invoiceHeader = ["Invoice Date", "Invoice Amount", "Invoice Number", "PO Number", "Vendor Name"];
    const fullPaymentHeader = ["Payment Mode", "Pay Amount", "Accounting Date", "Payment Date", "Payment Number"];
    const singlePaymentHeader = ["Payment Mode"];

    aoa.forEach((row, rowIndex) => {
      const trimmedRow = row.map(cell => (cell || "").toString().trim());
      const meaningful = trimmedRow.filter(cell => cell !== "");

      const isInvoiceHeader = JSON.stringify(meaningful) === JSON.stringify(invoiceHeader);
      const isFullPaymentHeader = JSON.stringify(meaningful) === JSON.stringify(fullPaymentHeader);
      const isSinglePaymentHeader = JSON.stringify(meaningful) === JSON.stringify(singlePaymentHeader);

      if (isInvoiceHeader || isFullPaymentHeader || isSinglePaymentHeader) {
        row.forEach((cellValue, colIndex) => {
          if (cellValue && cellValue.toString().trim() !== "") {
            const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
            const cell = ws[cellRef];
            if (cell) {
              cell.s = {
                fill: { fgColor: { rgb: "A03D57" } }, // Brown background
                font: { bold: true, color: { rgb: "FFFFFF" } }, // White bold text
              };
            }
          }
        });
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${fileName}.xlsx`);
  };

  const exportCSV1 = () => {
    const aoa = formatForExcel(data);
    exportCSVFormatted(aoa, `${fileName}.csv`);
  };

  const exportCSV2 = () => {
    const aoa = formatForExcel1(data);
    exportCSVFormatted(aoa, `${fileName}.csv`);
  };

  const exportCSV3 = () => {
    const aoa = formatForExcel2(data);
    exportCSVFormatted(aoa, `${fileName}.csv`);
  };

  const exportCSVFormatted = (aoa, filename) => {
    const invoiceHeader1 = ["Invoice Date", "Invoice Amount", "Invoice Number", "PO Number"];
    const invoiceHeader2 = ["Invoice Date", "Invoice Amount", "Invoice Number", "PO Number", "Vendor Name"];
    const invoiceHeader3 = ["Individual Invoice Amount", "Invoice Date", "Invoice Number", "PO Number", "Vendor Name"];
    const fullPaymentHeader = ["Payment Mode", "Pay Amount", "Accounting Date", "Payment Date", "Payment Number"];
    const singlePaymentHeader = ["Payment Mode"];

    const csvRows = aoa.map((row) => {
      const trimmed = row.map(cell => (cell || "").toString().trim());
      const meaningful = trimmed.filter(cell => cell !== "");

      const isHeader =
        JSON.stringify(meaningful) === JSON.stringify(invoiceHeader1) ||
        JSON.stringify(meaningful) === JSON.stringify(invoiceHeader2) ||
        JSON.stringify(meaningful) === JSON.stringify(invoiceHeader3) ||
        JSON.stringify(meaningful) === JSON.stringify(fullPaymentHeader) ||
        JSON.stringify(meaningful) === JSON.stringify(singlePaymentHeader);

      return trimmed.map(cell =>
        isHeader ? `${cell}` : `"${cell.replace(/"/g, '""')}"`
      ).join(",");
    });

    const csvContent = csvRows.join("\n");
    saveAs(new Blob([csvContent], { type: "text/csv;charset=utf-8;" }), filename);
  };

  const exportTSV1 = () => {
    const aoa = formatForExcel(data);
    exportTSVFormatted(aoa, `${fileName}.tsv`);
  };

  const exportTSV2 = () => {
    const aoa = formatForExcel1(data);
    exportTSVFormatted(aoa, `${fileName}.tsv`);
  };

  const exportTSV3 = () => {
    const aoa = formatForExcel2(data);
    exportTSVFormatted(aoa, `${fileName}.tsv`);
  };

  const exportTSVFormatted = (aoa, filename) => {
    const invoiceHeader1 = ["Invoice Date", "Invoice Amount", "Invoice Number", "PO Number"];
    const invoiceHeader2 = ["Invoice Date", "Invoice Amount", "Invoice Number", "PO Number", "Vendor Name"];
    const invoiceHeader3 = ["Individual Invoice Amount", "Invoice Date", "Invoice Number", "PO Number", "Vendor Name"];
    const fullPaymentHeader = ["Payment Mode", "Pay Amount", "Accounting Date", "Payment Date", "Payment Number"];
    const singlePaymentHeader = ["Payment Mode"];

    const tsvRows = aoa.map((row) => {
      const trimmed = row.map(cell => (cell || "").toString().trim());
      const meaningful = trimmed.filter(cell => cell !== "");

      const isHeader =
        JSON.stringify(meaningful) === JSON.stringify(invoiceHeader1) ||
        JSON.stringify(meaningful) === JSON.stringify(invoiceHeader2) ||
        JSON.stringify(meaningful) === JSON.stringify(invoiceHeader3) ||
        JSON.stringify(meaningful) === JSON.stringify(fullPaymentHeader) ||
        JSON.stringify(meaningful) === JSON.stringify(singlePaymentHeader);

      return trimmed.map(cell =>
        isHeader ? `${cell}` : `${cell.replace(/\t/g, ' ')}`
      ).join("\t");
    });

    const tsvContent = tsvRows.join("\n");
    saveAs(new Blob([tsvContent], { type: "text/tab-separated-values;charset=utf-8;" }), filename);
  };



  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(getData());
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${fileName}.xlsx`);
  };

  // Helper: CSV/TSV export
  const exportCSV = () => {
    const csv = Papa.unparse(getData());
    saveAs(new Blob([csv], { type: "text/csv" }), `${fileName}.csv`);
  };

  const exportTSV = () => {
    const tsv = Papa.unparse(getData(), { delimiter: "\t" });
    saveAs(new Blob([tsv], { type: "text/tab-separated-values" }), `${fileName}.tsv`);
  };

  // Helper: PDF export (simple table)
  const exportPDF = () => {
    const data = getData();
    const headers = Object.keys(data[0] || {});

    // Check if any header is too long (customize threshold)
    const isWideHeader = headers.some(h => h.length > 10); // adjust threshold as needed

    const doc = new jsPDF({
      orientation: isWideHeader ? "landscape" : "portrait",
      unit: "pt",
      format: isWideHeader ? "a3" : "a4",
    });

    const rows = data.map(row => headers.map(h => row[h]));

    doc.autoTable({
      head: [headers],
      body: rows,
      styles: {
        fontSize: isWideHeader ? 12 : 14,
        cellWidth: 'wrap',
        textColor: '#000000',             // Black text for body
        // fillColor: '#fff',         // White background
        lineColor: [220, 220, 220],         // Light grey border
        lineWidth: 0.05,
      },
      headStyles: {
        fontSize: isWideHeader ? 10 : 12,
        halign: 'center',
        fillColor: "#1abd9c",
        textColor: "#ffffff",
        lineWidth: 0,
      },
      margin: { top: 40 },
      startY: 40,
      tableWidth: 'auto',
    });

    doc.save(`${fileName}.pdf`);
  };

const exportPDFVendor = () => {
    const data = getData();
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);

    const isWideHeader = headers.some(h => h.length > 10);

    const doc = new jsPDF({
        orientation: isWideHeader ? "landscape" : "portrait",
        unit: "pt",
        format: isWideHeader ? "a3" : "a4",
    });

    const rows = data.map(row => headers.map(h => row[h]));

    doc.autoTable({
    head: [headers],
    body: rows,
    startY: 40,
    margin: { top: 40, left: 20, right: 20 },
    styles: {
        fontSize: isWideHeader ? 10 : 12,
        overflow: 'linebreak', 
        cellWidth: 'auto', 
        textColor: '#000000',
        lineColor: [220, 220, 220],
        lineWidth: 0.05,
    },
    headStyles: {
        fontSize: isWideHeader ? 10 : 12,
        fillColor: "#1abd9c",
        textColor: "#ffffff",
        halign: 'center',
    },
    columnStyles: {
        'Operating Categories': {
            cellWidth: 50, 
            overflow: 'linebreak',
        },
    },
    tableWidth: 'auto',
});
    doc.save(`${fileName}.pdf`);
};

  // Helper: XML export
  const exportXML = () => {
    const escapeXML = (str) =>
      String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");

    let xml = '<?xml version="1.0" encoding="UTF-8"?><rows>';
    data.forEach(row => {
      xml += "<row>";
      Object.entries(row).forEach(([key, value]) => {
        xml += `<${key}>${escapeXML(value)}</${key}>`;
      });
      xml += "</row>";
    });
    xml += "</rows>";
    saveAs(new Blob([xml], { type: "application/xml" }), `${fileName}.xml`);
  };

  return (
    <div className="flex flex-col list">
      <button onClick={fileName === "Contract Details" ? exportExcel1 : fileName === "Invoice Details" ? exportExcel2 : fileName === "PO Details" ? exportExcel3 : exportExcel}>Export Excel</button>
      <button onClick={
        fileName === "Contract Details" ? exportCSV1 :
          fileName === "Invoice Details" ? exportCSV2 :
            fileName === "PO Details" ? exportCSV3 :
              exportCSV
      }>
        Export CSV
      </button>
      <button onClick={
        fileName === "Contract Details" ? exportTSV1 :
          fileName === "Invoice Details" ? exportTSV2 :
            fileName === "PO Details" ? exportTSV3 :
              exportTSV
      }>
        Export TSV
      </button>
      {!(fileName === "Contract Details" || fileName === "Invoice Details" || fileName === "PO Details") && (
        // <>
        // {
        //   fileName = "LIST OF COUNTY VENDORS" ? 
        //   <button onClick={exportPDFVendor}>Export PDF</button> :
          <button onClick={exportPDFVendor}>Export PDF</button>
        // }
        // </>
        
      )}
      <button onClick={exportXML}>Export XML</button>
    </div>
    // LIST OF COUNTY VENDORS
  );
}

export default ExportButtons;